import { memo } from 'react';

import AddCircle from '@mui/icons-material/AddCircle';
import { Box, ListSubheader, IconButton, Tooltip } from '@mui/material';

import { InterviewCreationFormValues } from './types';
import { getNameFromId } from '@synergetx/puppet-interview-types';

interface Props {
    id: string;
    setInterviewCreationForm: (value: InterviewCreationFormValues) => void;
}

const GroupSubheader = ({ id, setInterviewCreationForm }: Props) => {
    const isNewGroup = !id;

    // "Add New Project" gets distinct styling as a call-to-action
    if (isNewGroup) {
        return (
            <Box
                onClick={() => setInterviewCreationForm({ groupId: id })}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mt: 1,
                    mx: 1,
                    p: 1,
                    borderRadius: 1,
                    border: '1px dashed',
                    borderColor: 'grey.400',
                    backgroundColor: 'grey.50',
                    cursor: 'pointer',

                    '&:hover': {
                        borderColor: 'primary.main',
                        backgroundColor: 'primary.50',
                    },
                }}
            >
                <ListSubheader
                    sx={{
                        color: 'text.secondary',
                        fontSize: 13,
                        fontWeight: 500,
                        backgroundColor: 'transparent',
                        p: 0,
                    }}
                >
                    Create New Project
                </ListSubheader>
                <Tooltip placement="right" title="Create new project">
                    <IconButton color="primary" size="small">
                        <AddCircle />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    }

    // Regular group header with accent styling
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderLeft: '3px solid',
                borderColor: 'primary.main',
                backgroundColor: 'grey.50',
                mt: 1,
            }}
        >
            <ListSubheader
                sx={{
                    color: 'text.primary',
                    fontSize: 14,
                    fontWeight: 700,
                    backgroundColor: 'transparent',
                }}
            >
                {getNameFromId(id)}
            </ListSubheader>
            <Tooltip placement="right" title={`Add Survey to ${getNameFromId(id)}`}>
                <span>
                    <IconButton
                        color="success"
                        size="small"
                        onClick={() => setInterviewCreationForm({ groupId: id })}
                    >
                        <AddCircle />
                    </IconButton>
                </span>
            </Tooltip>
        </Box>
    );
};

export default memo(GroupSubheader);
